<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@add="add"
			@search="search">
		</fab>

		<add ref="add" :user="user" :isAuth="isAuth" @reload="reload"></add>
		<search ref="search" :user="user" :isAuth="isAuth" @reload="reload"></search>
	</div>
</template>

<script>
	import fab from 'vue-fab'
	import Search from '@/components/search/layout/Search'
	import Add from './Add'
	export default {
		props: ['user', 'isAuth'],
		components: {
			fab,
			'search': Search,
			'add': Add,
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					tooltip: true,
					fabActions: [
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					],
				}
			}
		},
		methods: {
			add() {
				if(this.type == 'index') {
					this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/customers/create')
				} else {
					this.$refs.add.open()
				}
			},
			search() {
				this.$refs.search.open('customers')
			},
			reload() {
				this.$emit('reload')
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/dashboard/views/Fab.vue